import React, { Component } from "react";
import "./step-back-test.style.scss";
import { get } from "lodash";
import { Col, Row } from "react-bootstrap";
import ProductFinancialTable from "./components/ProductFinancialTable";

const toAmountValue = (input) => {
  return Number((+input).toFixed(2)).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

function toPercentValue(value, defaultVal) {
  const num = parseFloat(value);
  if (!num || !isFinite(num) || num === 0) {
    return defaultVal !== undefined ? toPercentValue(defaultVal) : "0%";
  }
  const pct = num * 100;
  if (!isFinite(pct) || Math.abs(pct) > 100000) {
    return defaultVal !== undefined ? toPercentValue(defaultVal) : "0%";
  }
  return `${pct.toFixed(2)}%`;
}

export default class StepBackTest extends Component {
  render() {
    const backtest = get(this.props, "backTestData.backtest", {});
    const processing = get(this.props, "backTestData.processing", {});
    const custSummary = get(this.props, "backTestData.summary.customer", null);
    const segSummary = get(this.props, "backTestData.summary.segment", null);
    const segmentName = get(
      this.props,
      "backTestData.summary.segment_name",
      "",
    );
    return (
      <div className="step-back-test">
        <Row>
          <Col xs={8}>
            <div className="result-card">
              <div className="result-card__header">
                <span className="card-title">Proposed Rate Result</span>
                <span className="badge-result">{backtest.result || "Amt"}</span>
              </div>

              <div className="result-row even">
                <dt>Estimated pricing rate</dt>
                <dl>7.49%</dl>
              </div>

              <div className="result-row odd">
                <dt>Total Risk Weighted Asset</dt>
                <dl>{toAmountValue(backtest.total_risk_weighted_asset)}</dl>
              </div>

              <div className="result-row even">
                <dt>Total EAD</dt>
                <dl>{toAmountValue(backtest.total_ead)}</dl>
              </div>

              <div className="result-row odd">
                <dt>Capital Required</dt>
                <dl>{toAmountValue(backtest.capital_required)}</dl>
              </div>

              <div className="group-header">Interest Income</div>

              <div className="result-row even">
                <dt>Interest Income</dt>
                <dl>
                  {toAmountValue(
                    get(backtest, "interest_income.interest_income", 0),
                  )}
                </dl>
              </div>

              <div className="result-row odd">
                <dt>Cost of funds</dt>
                <dl>
                  {toAmountValue(
                    get(backtest, "interest_income.cost_of_funds", 0),
                  )}
                </dl>
              </div>

              <div className="result-row even">
                <dt>Expected Loss (EL)</dt>
                <dl>
                  {toAmountValue(
                    get(backtest, "interest_income.expected_loss", 0),
                  )}
                </dl>
              </div>

              <div className="result-row odd">
                <dt>OPEX</dt>
                <dl>
                  {toAmountValue(get(backtest, "interest_income.opex", 0))}
                </dl>
              </div>

              <div className="result-row even">
                <dt>Net Contributed Before Tax</dt>
                <dl>{toAmountValue(backtest.net_contributed_before_tax)}</dl>
              </div>

              <div className="result-row even">
                <dt>Taxes @ 20%</dt>
                <dl>{toAmountValue(backtest.taxes)}</dl>
              </div>

              <div className="highlight-row">
                <dt>Net Contributed After Tax</dt>
                <dl>{toAmountValue(backtest.net_contributed_after_tax)}</dl>
              </div>

              <div className="highlight-row">
                <dt>RAROC</dt>
                <dl>{toPercentValue(backtest.raroc)}</dl>
              </div>

              <div className="highlight-row">
                <dt>Return on Risk Weighted Assets (RORWA)</dt>
                <dl>
                  {toPercentValue(backtest.return_on_risk_weighted_assets)}
                </dl>
              </div>
            </div>
          </Col>

          <Col xs={4}>
            <div className="proposed-rate-card">
              <div className="proposed-rate-card__header">
                Proposed Interest Rate
              </div>
              <div className="proposed-rate-card__body">
                <div className="rate-input-group">
                  <input className="form-control" defaultValue="" />
                  <button
                    type="button"
                    className="btn-run"
                    onClick={() => this.setState({ openNew: true })}
                  >
                    RUN
                  </button>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <div className="section-divider">Propose new Loan</div>

        <Row>
          <ProductFinancialTable />
        </Row>

        <Row>
          <Col xs={12}>
            <div className="summary-section">
              <div className="summary-section__title">
                2.1 RAROC/RORWA by Customer
              </div>
              <table className="summary-section__table">
                <thead>
                  <tr>
                    <th>Indicators</th>
                    <th>Current value</th>
                    <th>With new products</th>
                    <th>With potential products</th>
                    <th>Yearly target</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { label: "RAROC", key: "raroc" },
                    {
                      label: "Return on Risk Weighted Assets (RORWA)",
                      key: "rorwa",
                    },
                  ].map((row) => {
                    const target = custSummary ? custSummary[row.key][3] : null;
                    const cc = (val) =>
                      !custSummary
                        ? ""
                        : val >= target
                          ? "value-green"
                          : "value-red";
                    return (
                      <tr key={row.key}>
                        <td>{row.label}</td>
                        <td
                          className={cc(custSummary && custSummary[row.key][0])}
                        >
                          {custSummary
                            ? toPercentValue(custSummary[row.key][0])
                            : ""}
                        </td>
                        <td
                          className={cc(custSummary && custSummary[row.key][1])}
                        >
                          {custSummary
                            ? toPercentValue(custSummary[row.key][1])
                            : ""}
                        </td>
                        <td
                          className={cc(custSummary && custSummary[row.key][2])}
                        >
                          {custSummary
                            ? toPercentValue(custSummary[row.key][2])
                            : ""}
                        </td>
                        <td>
                          {custSummary
                            ? toPercentValue(custSummary[row.key][3])
                            : ""}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              <div className="summary-section__title">
                2.2 RAROC/RORWA by Segment
                {segmentName ? (
                  <span className="summary-section__segment">
                    {" "}
                    — {segmentName}
                  </span>
                ) : null}
              </div>
              <table className="summary-section__table">
                <thead>
                  <tr>
                    <th>Indicators</th>
                    <th>Current value</th>
                    <th>With new products</th>
                    <th>With potential products</th>
                    <th>Yearly target</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    {
                      label: "Estimated annualized TOI",
                      key: "toi",
                      type: "amount",
                    },
                    { label: "Total EAD", key: "ead", type: "amount" },
                    { label: "Total RWA", key: "rwa", type: "amount" },
                    {
                      label: "Net Contributed After Tax",
                      key: "net_after_tax",
                      type: "amount",
                    },
                    { label: "RAROC", key: "raroc", type: "percent" },
                    { label: "RORWA", key: "rorwa", type: "percent" },
                  ].map((row) => {
                    const fmt =
                      row.type === "percent" ? toPercentValue : toAmountValue;
                    const target =
                      segSummary && row.type === "percent"
                        ? segSummary[row.key][3]
                        : null;
                    const cc = (val) =>
                      target === null
                        ? ""
                        : val >= target
                          ? "value-green"
                          : "value-red";
                    return (
                      <tr key={row.key}>
                        <td>{row.label}</td>
                        <td
                          className={cc(segSummary && segSummary[row.key][0])}
                        >
                          {segSummary ? fmt(segSummary[row.key][0]) : ""}
                        </td>
                        <td
                          className={cc(segSummary && segSummary[row.key][1])}
                        >
                          {segSummary ? fmt(segSummary[row.key][1]) : ""}
                        </td>
                        <td
                          className={cc(segSummary && segSummary[row.key][2])}
                        >
                          {segSummary ? fmt(segSummary[row.key][2]) : ""}
                        </td>
                        <td>{segSummary ? fmt(segSummary[row.key][3]) : ""}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <div className="btns">
              <button
                type="button"
                className="btn btn-prev"
                onClick={this.props.onPrev}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-next"
                onClick={this.props.onSubmit}
              >
                Save
              </button>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/Pricing/NewPricing/StepBackTest.js